export const PAY_SORT_OPTIONS = [
  { value: "position", label: "Position" },
  { value: "client", label: "Client" },
  { value: "pay_rate", label: "Pay rate" },
];

export function buildPersonnelPayFilterChips({ showDeleted }) {
  if (!showDeleted) return [];
  return [
    {
      id: "deleted",
      key: "showDeleted",
      fieldId: "pay-show-deleted",
      label: "Show Deleted",
    },
  ];
}

export function countPersonnelPayActiveFilters({ showDeleted }) {
  return showDeleted ? 1 : 0;
}
